import styled from '@emotion/styled';

/**
 * Container for the entire Ask NikeAI search result
 * Houses the shimmer button and query display
 * Responsive padding for mobile
 * TG-8222: Changed from div to button for proper keyboard navigation
 */
export const StyledContainer = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 600px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  text-align: left;

  @media (max-width: 959px) {
    max-width: 100%;
  }

  &:focus-visible {
    outline: 2px solid var(--podium-cds-color-black);
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

/**
 * Query display text
 * Shows the user's search query
 * Uses div for multi-line wrapping support (inputs can't wrap)
 */
export const StyledQueryDisplay = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 24px;
  padding: 12px 0;
  font: var(--podium-cds-typography-body1-strong);
  color: var(--podium-cds-color-text-primary, #111111);
  cursor: pointer;
  pointer-events: none;
  line-height: 1.5;

  /* Allow text to wrap for long queries (mobile) */
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;

  /* Desktop: limit display to 250 chars (truncated in JS) */
`;
